// DO NOT MODIFY - this file is auto-generated by build-icons.js
// @ts-nocheck
import React from 'react';
import Icon from '../shared/icon';

/* eslint-disable react/jsx-max-props-per-line,react/jsx-space-before-closing,react/jsx-tag-spacing */

const ForwardIcon = (props) => (
  <Icon {...props}>
    {
      ({ color, width, height }) => (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 100 100">
          <path d="M38.928 92.236L73.923 57.24a10.387 10.387 0 0 0 3.05-7.417 10.388 10.388 0 0 0-3.05-7.417L38.928 7.41c-4.07-4.068-10.665-4.068-14.734 0-4.07 4.07-4.07 10.666 0 14.734l27.68 27.68L24.194 77.5c-4.07 4.07-4.07 10.665 0 14.734 4.07 4.07 10.664 4.07 14.733 0"/>
        </svg>
      )
    }
  </Icon>
);

export default ForwardIcon;
